"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendaPostergada = void 0;
var bson_1 = require("bson");
var VendaPostergada = /** @class */ (function () {
    function VendaPostergada(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.pv, pv = _c === void 0 ? '' : _c, _d = _a.material, material = _d === void 0 ? '' : _d, _e = _a.grade, grade = _e === void 0 ? '' : _e, _f = _a.quantidade, quantidade = _f === void 0 ? 0 : _f;
        this._id = _id;
        this.pv = pv;
        this.material = material;
        this.grade = grade;
        this.quantidade = quantidade;
    }
    return VendaPostergada;
}());
exports.VendaPostergada = VendaPostergada;
//# sourceMappingURL=VendaPostergada.js.map